module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pl-dialog', {
    attrs: {
      "padding": "0 0 20px 0",
      "size": 'lg',
      "disableOutsideClick": true,
      "title": _vm.activityType == 'live' ?
        'Welcome to the Verbal RoundTable' :
        'Welcome to the Written RoundTable'
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "main-container w-100 h-100 flex justify-center mt-5 py-16",
    staticStyle: {
      "overflow": "auto"
    }
  }, [(_vm.hasTeacherPermissionsInCourse && _vm.showTeacher) ? _c('div', {
    staticClass: "card-video-body col-xs-5 col-sm-5 col-md-5 col-lg-5"
  }, [_c('h3', {
    staticClass: "modal-sub-title"
  }, [_vm._v("For Teachers")]), _vm._v(" "), _c('div', {
    staticClass: "video-container"
  }, [_c('iframe', {
    attrs: {
      "width": "100%",
      "height": "100%",
      "src": _vm.welcomeSettingsForTeacher.video_url,
      "frameborder": "0",
      "allow": "autoplay; encrypted-media",
      "allowfullscreen": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mt3",
    staticStyle: {
      "text-align": "center !important"
    }
  }, _vm._l((_vm.welcomeSettingsForTeacher.links), function(link, index) {
    return _c('div', {
      staticClass: "mt1"
    }, [_c('a', {
      key: index,
      staticClass: "row tutorials-list no-margin middle-xs between-xs",
      staticStyle: {
        "margin": "10px 0px"
      },
      attrs: {
        "href": link.url,
        "target": "_blank"
      }
    }, [_vm._v("\n              " + _vm._s(link.name) + "\n            ")])])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.showStudent) ? _c('div', {
    staticClass: "card-video-body col-xs-5 col-sm-5 col-md-5 col-lg-5"
  }, [_c('h3', {
    staticClass: "modal-sub-title"
  }, [_vm._v("For Students")]), _vm._v(" "), _c('div', {
    staticClass: "video-container"
  }, [_c('iframe', {
    attrs: {
      "width": "100%",
      "height": "100%",
      "src": _vm.welcomeSettingsForStudent.video_url,
      "frameborder": "0",
      "allow": "autoplay; encrypted-media",
      "allowfullscreen": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mt3",
    staticStyle: {
      "text-align": "center !important"
    }
  }, _vm._l((_vm.welcomeSettingsForStudent.links), function(link, index) {
    return _c('div', {
      staticClass: "mt1",
      on: {
        "click": function($event) {
          return _vm.openLinkNewTab(link.url)
        }
      }
    }, [_c('a', {
      key: index,
      staticClass: "row tutorials-list no-margin middle-xs between-xs",
      staticStyle: {
        "margin": "10px 0px"
      },
      attrs: {
        "href": link.url,
        "target": "_blank"
      }
    }, [_vm._v("\n              " + _vm._s(link.name) + "\n            ")])])
  }), 0)])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-58f092f7!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/modals/roundTableWelcomeModal.vue
// module id = 1047
// module chunks = 61